/*
 * $Id:: model.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { me } from '../AuthenticatedPage/authenticationSlice';
import { fetchApplicationsPaginated, fetchApplicationsExport } from '../MyApplicationsPage/service';
import { SLICE_NAME } from './constants';
import { deleteApplication, resumeApplication } from './service';

function* requestDraftApplications(action) {
    const { userId, parentUserId } = yield select(me);
    yield all([put({ type: `${SLICE_NAME}/loading`, payload: true }), put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(fetchApplicationsPaginated, {
        ...action.payload,
        userId: parentUserId ? parentUserId : userId,
    });
    if (!response.error) {
        yield put({
            type: `${SLICE_NAME}/list`,
            payload: response,
        });
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: { message: response.error.description, extraInfo: response.error.extraInfo } });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* getDraftApplications() {
    yield takeLatest(`${SLICE_NAME}/requestDraftApplications`, requestDraftApplications);
}

function* requestDraftApplicationDelete(action) {
    yield all([put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(deleteApplication, {
        ...action.payload,
    });
    if (!response.error) {
        // update table list
        yield call(requestDraftApplications, action.payload.actionParams);
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: { description: response.error.description, details: response.error.details || '' } });
    }
}

function* deleteDraftApplication() {
    yield takeLatest(`${SLICE_NAME}/requestDraftApplicationDelete`, requestDraftApplicationDelete);
}

function* requestResumeDraftApplication(action) {
    yield all([put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(resumeApplication, {
        ...action.payload,
    });
    if (!response.error) {
        const redirectUrl = response.url;
        if (!!redirectUrl) {
            window.open(redirectUrl, '_blank');
        }
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: { description: response.error.description, details: response.error.details || '' } });
    }
}

function* resumeDraftApplication() {
    yield takeLatest(`${SLICE_NAME}/requestResumeDraftApplication`, requestResumeDraftApplication);
}

function* requestMyDraftsExport(action) {
    const { type, applicationType } = action.payload.params;
    yield all([
        put({
            type: `${SLICE_NAME}/exportLoading`,
            payload: `drafts.${applicationType !== 'patents' ? applicationType + 's' : applicationType}.${type}.export.loading.text`,
        }),
        put({ type: `${SLICE_NAME}/error`, payload: false }),
    ]);
    const response = yield call(fetchApplicationsExport, {
        ...action.payload,
    });
    if (!response.error) {
        const filename = response.headers.get('Content-Disposition').split('filename=')[1].replace(/"/g, '');
        response.blob().then((blob) => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
        });
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: response.error.description });
    }
    yield put({ type: `${SLICE_NAME}/exportLoading`, payload: false });
}

function* getMyDraftsExport() {
    yield takeLatest(`${SLICE_NAME}/requestMyDraftsExport`, requestMyDraftsExport);
}

export { getDraftApplications, deleteDraftApplication, resumeDraftApplication, getMyDraftsExport };
